export enum OptimizationType {
    OPTIMISE = 'OPTIMIZE',
    SLOTIN = 'SLOTIN',
}
export enum ApproachType {
    UNRESTRICTED = 'Unrestricted',
    VEHICLE = 'Vehicle',
    CURB = 'Curb',
}

export enum TransactionType {
    PREVIEW = 'Preview',
    COMMIT = 'Commit',
}